export default {
  message: {
    Tour: {
      continue: "جاری رکھیں",
      back: "واپس",
      finish: "ختم کریں"
    },
    Login: {
      title: "والدین سائن ان",
      sign_in: "سائن ان کریں",
      login_fail:
        "تصدیق ناکام۔ براہ کرم دوبارہ کوشش کریں یا سائن ان میں مدد کے لیے اپنے اسکول سے رابطہ کریں۔",
      forgot_password: "پاس ورڈ بھول گئے",
      create_account: "اکاؤنٹ بنائیں",
      password: "پاس ورڈ",
      confirm_password: "پاس ورڈ کی تصدیق کریں",
      password_reminder: "پاس ورڈ یاد دہانی",
      enter_email: "اپنا ای میل ایڈریس درج کریں",
      validation_error: "توثیق کی خرابی کا پیغام",
      password_reminder_error_no_user_register:
        "آپ نے جو یوزر نیم درج کیا وہ نہیں ملا۔ براہ کرم دوبارہ کوشش کریں یا نیا اکاؤنٹ بنائیں۔",
      password_reminder_error_no_user: "آپ نے جو یوزر نیم درج کیا وہ نہیں ملا۔",
      password_reminder_sent: "مزید ہدایات کے ساتھ ایک ای میل {email} پر بھیجا گیا ہے۔",
      password_reminder_sent_message:
        "ای میل آنے میں چند منٹ لگ سکتے ہیں۔ اگر آپ کو اپنے انباکس میں نظر نہیں آتا تو اپنا سپیم فولڈر چیک کریں۔",
      password_trouble_email: "اگر آپ کو اب بھی پریشانی ہو رہی ہے تو براہ کرم {email} سے رابطہ کریں۔",
      password_trouble_school:
        "اگر آپ کو اب بھی پریشانی ہو رہی ہے تو براہ کرم مدد کے لیے اپنے اسکول سے رابطہ کریں۔",
      return_to_sign_in: "سائن ان پر واپس جائیں",
      create_my_account: "میرا اکاؤنٹ بنائیں",
      or_sign_in_with: "یا اس کے ساتھ سائن ان کریں",
      password_reset: "براہ کرم اپنے اکاؤنٹ کے لیے نیا پاس ورڈ چنیں۔",
      password_reset_warning:
        "اگر آپ نے اپنا پاس ورڈ تبدیل کرنے کی درخواست نہیں کی تو براہ کرم فوری طور پر اپنے اسکول ایڈمنسٹریٹر سے رابطہ کریں۔",
      password_update: "نیا پاس ورڈ چنیں",
      password_update_confirm: "نئے پاس ورڈ کی تصدیق کریں",
      password_update_success: "آپ کا نیا پاس ورڈ محفوظ کر لیا گیا ہے۔"
    },
    AccountSettings: {
      title: "اکاؤنٹ کی ترتیبات",
      first_name: "پہلا نام",
      last_name: "آخری نام",
      email: "ای میل",
      username: "یوزر نیم",
      password: "پاس ورڈ",
      students: "طلباء",
      teachers: "اساتذہ",
      external_id: "بیرونی آئی ڈی",
      phone: "فون نمبر",
      phone_required: "فون نمبر درکار ہے",
      edit: "ترمیم",
      remove: "ہٹائیں",
      add: "شامل کریں",
      remove_message: "کیا آپ واقعی اس طالب علم کا نام ہٹانا چاہتے ہیں؟",
      yes: "جی ہاں",
      no: "نہیں",
      add_student: "طالب علم شامل کریں",
      close: "بند کریں",
      save: "تبدیلیاں محفوظ کریں",
      cancel: "منسوخ کریں",
      student_alert_message: "آپ کو کم از کم ایک طالب علم درج کرنا ہوگا۔",
      logout: "لاگ آؤٹ"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    Navbar: {
      my_meetings: "میری ملاقاتیں",
      language: "اردو",
      help: "مدد",
      account_settings: "اکاؤنٹ کی ترتیبات",
      user_management: "User Management",
      logout: "لاگ آؤٹ"
    },
    SubNavbar: {
      meeting: "ملاقات",
      event: "واقعہ",
      print: "پرنٹ",
      email: "ای میل",
      export: "ایکسپورٹ"
    },
    ConferenceCard: {
      add_edit_meetings: "ملاقاتیں شامل/ترمیم کریں",
      opening: "کھل رہا ہے",
      closed: "بند"
    },
    Agenda: {
      full_agenda: "مکمل ایجنڈا",
      empty_state_title: "ہم آپ کے لیے کوئی کانفرنس نہیں ڈھونڈ سکے۔",
      empty_state_message: "اگر آپ کے کوئی سوالات ہیں تو براہ کرم اپنے اسکول کے نمائندے سے رابطہ کریں۔",
      confirmation_modal_title: "ایجنڈا کی تصدیق",
      confirmation_modal_message:
        "آپ کے ایجنڈا کی کامیابی سے تصدیق ہو گئی ہے اور آپ کو ایک ای میل بھیجا گیا ہے۔",
      complete_button: "مکمل!"
    },
    AgendaCard: {
      room: "کمرہ دستیاب نہیں",
      room_with_value: "کمرہ: {room}",
      virtual_meeting: "ورچوئل ملاقات",
      all_conferences: "تمام کانفرنسیں",
      conference: "کانفرنس",
      student: "طالب علم",
      meeting_with: "ملاقات کے ساتھ",
      date_time: "تاریخ/وقت",
      meeting_type: "ملاقات کی قسم",
      location: "مقام",
      comment: "تبصرہ",
      action: "عمل",
      delete: "حذف کریں",
      add_comment: "تبصرہ شامل کریں",
      join: "ملاقات میں شامل ہوں",
      choose_meeting_type: "ملاقات کی قسم چنیں",
      in_person: "ذاتی طور پر",
      phone: "فون",
      callback: "کال بیک",
      virtual: "ورچوئل",
      hybrid: "ہائبرڈ",
      unavailable: "دستیاب نہیں",
      tooltip_translator:
        "مترجم کی خدمت کی ضمانت نہیں ہے لیکن اسکول اس کی دستیابی کو یقینی بنانے کی ہر ممکن کوشش کرے گا۔",
      translator_requested: "مترجم کی درخواست کی گئی",
      clear_translator: "مترجم کی درخواست صاف کریں",
      need_translator: "مترجم کی ضرورت ہے؟",
      choose_language: "زبان چنیں"
    },
    ScheduleMatrix: {
      no_teachers_title: "کوئی اساتذہ یا ٹیمیں منتخب نہیں ہیں۔",
      no_teachers_message: "ان کے ملاقات کے اوقات دیکھنے کے لیے براہ کرم ایک استاد کا انتخاب کریں۔",
      choose_teachers_button: "دستیاب اساتذہ یا ٹیمیں دیکھیں",
      choose_student: "کس طالب علم کے لیے؟",
      cancel: "منسوخ کریں"
    },
    Matrix: {
      teachers: "اساتذہ",
      agenda: "جائزہ لیں اور جاری رکھیں"
    },
    DrawerTeachers: {
      teachers: "اساتذہ",
      name: "نام",
      description: "تفصیل",
      student: "طالب علم",
      teacher_team: "استاد/ٹیم",
      show_more: "مزید اساتذہ دکھائیں",
      show_all: "اسکول کے تمام اساتذہ دکھائیں",
      selected: "({count}) منتخب",
      closeDrawer: "شیڈول پر جاری رکھیں",
      search: "استاد یا ٹیم تلاش کریں",
      not_available: "اس استاد کے پاس {date} کو کوئی دستیاب ملاقات کا وقت نہیں ہے۔"
    },
    DrawerAgenda: {
      no_meetings_title: "آپ کی کوئی ملاقات شیڈول نہیں ہے۔",
      no_meetings_message: "جب آپ ایک استاد اور ٹائم سلاٹ چن لیں گے تو یہ یہاں ظاہر ہوگا۔",
      new_meeting_label: "نیا",
      cancel_button: "منسوخ کریں",
      student_label: "طالب علم",
      meeting_type_location: "ملاقات کی قسم/مقام",
      comment_label: "تبصرہ",
      save_comment_button: "تبصرہ محفوظ کریں",
      confirm_label: "براہ کرم تصدیق کریں:",
      confirm_cancel_button: "جی ہاں، میری ملاقات منسوخ کریں ",
      do_not_cancel_button: "منسوخ نہ کریں",
      confirm_agenda_button: "اس ایجنڈا کی تصدیق کریں",
      confirm_agenda_message_line1: "آپ ہمیشہ واپس آ کر تبدیلیاں کر سکتے ہیں۔",
      confirm_agenda_message_line2: "آپ کا موجودہ ایجنڈا آپ کو ای میل کیا جائے گا۔"
    },
    EmailConsent: {
      message:
        "آپ کی رازداری اور سیکیورٹی کے تحفظ کی کوشش میں، ہمیں آپ کی رضامندی کی ضرورت ہے کہ آپ ہمارے سسٹم سے اپنے ای میل ایڈریس پر مواصلات وصول کریں۔",
      consent: "رضامندی"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
